import { TextField, type ITextFieldStyles } from "@fluentui/react/lib/TextField";
import * as React from "react";
import type { FtlPanelFormData } from "./ftlFormModel";

export function FtlShipmentZipsDateFields({
  formData,
  errors,
  onInputChange,
  onPersistBlur,
  getTextFieldStyles,
}: {
  formData: FtlPanelFormData;
  errors: Record<string, string>;
  onInputChange: (
    event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    newValue?: string
  ) => void;
  onPersistBlur: () => void;
  getTextFieldStyles: (fieldName: string) => Partial<ITextFieldStyles>;
}): React.ReactElement {
  return (
    <>
      <TextField
        label="Origin ZIP"
        name="originZip"
        value={formData.originZip}
        onChange={onInputChange}
        onBlur={onPersistBlur}
        required
        styles={getTextFieldStyles("originZip")}
        errorMessage={errors.originZip}
      />
      <TextField
        label="Origin State"
        name="originState"
        value={formData.originState}
        onChange={onInputChange}
        onBlur={onPersistBlur}
        styles={getTextFieldStyles("originState")}
      />
      <TextField
        label="Destination ZIP"
        name="destinationZip"
        value={formData.destinationZip}
        onChange={onInputChange}
        onBlur={onPersistBlur}
        required
        styles={getTextFieldStyles("destinationZip")}
        errorMessage={errors.destinationZip}
      />
      <TextField
        label="Destination State"
        name="destinationState"
        value={formData.destinationState}
        onChange={onInputChange}
        onBlur={onPersistBlur}
        styles={getTextFieldStyles("destinationState")}
      />
      <TextField
        label="Pickup Date"
        name="pickupDate"
        value={formData.pickupDate}
        onChange={onInputChange}
        onBlur={onPersistBlur}
        type="date"
        required
        styles={getTextFieldStyles("pickupDate")}
        errorMessage={errors.pickupDate}
      />
    </>
  );
}
